export default __webpack_public_path__ + "images/google2FA_f4c087.svg";